import { Box } from '@user-portal/wikr-components';
import styled from 'styled-components';

interface SkeletonProps {
    width?: number;
    height?: number;
    $borderRadius?: number;
    $marginLeft?: number;
    $marginTop?: number;
    $mb?: number;
}

export const SkeletonContainer = styled(Box).attrs(
    ({ $borderRadius, $marginLeft, $marginTop, $mb }: SkeletonProps) => ({
        $borderRadius,
        $marginLeft,
        $marginTop,
        $mb,
    })
)<SkeletonProps>`
    width: ${({ width }) => (typeof width === 'number' ? `${width}px` : '100%')};
    height: ${({ height }) => (typeof height === 'number' ? `${height}px` : 'auto')};
    border-radius: ${({ $borderRadius }) => ($borderRadius ? `${$borderRadius}px` : '0px')};
    margin-bottom: ${({ $mb }) => ($mb ? `${$mb}px` : '0px')};
    margin-left: ${({ $marginLeft = 0 }) => $marginLeft}px;
    margin-top: ${({ $marginTop = 0 }) => $marginTop}px;
    overflow: hidden;
    position: relative;

    svg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }
`;
